import {
  TableHeading,
  TableSortingDirection,
} from 'app/components/shared/Table'
import { SponsorRequest, SponsorRequestStatus } from 'EstraSponsor'

export const INITIAL_SORT_DIRECTION: TableSortingDirection = 'DESC'
export const INITIAL_SORT_KEY: TableHeadingsKeys = 'sent_at'

export type TableHeadingsKeys = keyof Pick<
  SponsorRequest,
  'sent_at' | 'name' | 'status'
>

export const tableHeadings: TableHeading<TableHeadingsKeys>[] = [
  {
    key: 'sent_at',
    label: 'Data richiesta',
    sortable: true,
  },
  {
    key: 'name',
    label: 'Nome',
    sortable: true,
  },
  {
    key: 'status',
    label: 'Stato',
    sortable: true,
  },
]

// FILTERS

export type SponsorRequestStatusFilters =
  | 'all'
  | Extract<
      SponsorRequestStatus,
      | 'draft'
      | 'new'
      | 'rejected'
      | 'in_progress'
      | 'approved_with_changes'
      | 'approved'
      | 'finalized_to_sign'
      | 'finalized'
      | 'canceled'
      | 'expired'
    >

export type SponsorRequestFilterStatusDictionary = Record<
  SponsorRequestStatusFilters,
  {
    label: string
    statuses?: SponsorRequestStatus[]
  }
>

export const filterStatusDictionary: SponsorRequestFilterStatusDictionary = {
  all: {
    label: 'Tutti gli stati',
  },
  draft: {
    label: 'Bozze',
    statuses: ['draft'],
  },
  new: {
    label: 'Nuove',
    statuses: ['new'],
  },
  rejected: {
    label: 'Rifiutate',
    statuses: ['rejected'],
  },
  in_progress: {
    label: 'In elaborazione',
    statuses: ['in_progress', 'finalized_signed'],
  },
  approved_with_changes: {
    label: 'Approvate con modifiche',
    statuses: ['approved_with_changes'],
  },
  approved: {
    label: 'Approvate',
    statuses: ['approved'],
  },
  finalized: {
    label: 'Completate',
    statuses: ['finalized'],
  },
  finalized_to_sign: {
    label: 'Da firmare',
    statuses: ['finalized_to_sign'],
  },
  canceled: {
    label: 'Eliminate',
    statuses: ['canceled'],
  },
  expired: {
    label: 'Scadute',
    statuses: ['expired'],
  },
}

export const getFilteredRequests = (
  data: SponsorRequest[],
  activeStatusFilter: SponsorRequestStatusFilters
): SponsorRequest[] => {
  let filteredRequests: SponsorRequest[] = data

  if (activeStatusFilter === 'all') return filteredRequests

  const filter = filterStatusDictionary[activeStatusFilter]

  filteredRequests = data.filter(({ status }) => {
    return filter.statuses ? filter.statuses.includes(status) : true
  })

  // Other filters...

  return filteredRequests
}
